import { Component, OnInit } from '@angular/core';
import { Router,NavigationEnd  } from '@angular/router';
import { AccountService } from './_services/account.service';
import { TokenStorageService } from './_services/token-storage.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'Mon-toit';
  isLoggedIn = false;
  isForeman = false;
  contactUUID: string = "";
  accoundId: number = 0;
  username?: string;
  first_name?: string;
  last_name?: string;
  useraccess?: any;
  currentRoute: string = "";

  constructor(
    private account: AccountService,
    private tokenStorage: TokenStorageService, 
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log('window', window)
    this.isLoggedIn = !!this.tokenStorage.getToken();
    this.checkLogin();
    //console.log('********************window[CKEDITOR]', CKEditor);

    
  }

  checkLogin(): void {

    console.log('checking login url: ',this.route);
    //this.isLoggedIn = !!this.tokenStorage.getToken();

    if (this.isLoggedIn) {
      const user = this.tokenStorage.getUser();
      this.contactUUID = this.tokenStorage.getToken() || "";
      this.useraccess = this.tokenStorage.getUserAccess() || "";
      console.log('user', user['account_id'])

      if(user['account_id'] == 20) {
        this.isForeman = true;
      }

      this.tokenStorage.getUserInfo().subscribe({
        next: (data: any) => {
          this.username = data.login;
          this.accoundId = data.account_id;
          this.first_name = data.first_name;
          this.last_name = data.last_name;
        },
        error: (err: any) => {
          console.log("Something went wrong getting the user info: ", err)
          this.logout();
        }
      });
    }
    // else {
    //   // this.logout();
    // }
  }

  logout(): void {
    this.isLoggedIn = false;
    this.isForeman = false;
    console.log('logging out');
    this.router.navigate(['/connexion'])
    .then(() => {
      this.tokenStorage.signOut();
    });
  }
}